import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { GeneralStore } from "../../../../../../services/store/general";
import { MC_APPLICATIONS_ERROR, MCFormatTextPipe } from "@maslul/common-services";


@Component({
    selector: 'mi-unauthorized',
    imports: [
        MCFormatTextPipe
    ],
    templateUrl: './unauthorized.html',
    styleUrl: './unauthorized.scss',
    encapsulation: ViewEncapsulation.None
})
export class UnauthorizedComponent implements OnInit {
    subscription: Subscription = new Subscription();
    errorText: any;

    constructor(
        private translateService: TranslateService) {

    }


    ngOnInit() {
        this.initText();
    }


    initText() {

        this.subscription.add(this.translateService.stream('error').subscribe(translation => {
            this.errorText = translation;
        }));

    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}


